import Vue from 'vue'

import Qs from 'qs'

class Revenues {
  async suggestOnlyAlertBalance() {
    return await Vue.axios
      .get('app/revenues/suggest/only-alert-balance')
  }

  async indexAccount({accountId, params}) {
    return await Vue.axios
      .get('app/revenues/by-account/' + accountId, {
        params,
        paramsSerializer: (params) => {
          return Qs.stringify(params)
        }
      })
  }

  async createAccount({accountId, data}) {
    return await Vue.axios
      .post('app/revenues/by-account/' + accountId, data)
  }

  async read({id}) {
    return await Vue.axios
      .get('app/revenues/' + id)
  }

  async update({id, data}) {
    return await Vue.axios
      .put('app/revenues/' + id, data)
  }

  async delete({id}) {
    return await Vue.axios
      .delete('app/revenues/' + id)
  }
}

const revenues = new Revenues()

export default revenues
